<a matRipple matRippleCentered="true" class="toggle" (click)="toggle()">
  <mat-icon color="primary" *ngIf="open" aria-hidden="false" aria-label="Toggle panel">navigate_next</mat-icon>
  <mat-icon color="primary" *ngIf="!open" aria-hidden="false" aria-label="Toggle panel">navigate_before</mat-icon>
</a>

<div class="content" [class]="open ? 'open' : 'close'">
  <h2>Rapports des sous-systèmes</h2>

  <kendo-grid
    #kendoGrid
    [data]="gridWrapper.gridData"
    [loading]="gridWrapper.loading"
    kendoGridSelectBy="id"
    [height]="bodyHeight - 64 - 18"
    scrollable="virtual"
    rowHeight="54px"
    [skip]="gridWrapper.gridState.skip"
    [pageSize]="gridWrapper.gridState.take"
    [sortable]="true"
    [groupable]="true"
    [reorderable]="true"
    [resizable]="true"
    filterable="menu"
    [group]="gridWrapper.gridState.group"
    [sort]="gridWrapper.gridState.sort"
    (groupChange)="gridWrapper.groupChanged($event)"
    (dataStateChange)="gridWrapper.onDataStateChange($event)"
  >
    <kendo-grid-messages groupPanelEmpty="Déplacer ici l'entête d'une colonne pour grouper..."> </kendo-grid-messages>

    <ng-template kendoGridToolbarTemplate>
      <input #mainFilter placeholder="Rechercher..." kendoTextBox (input)="gridWrapper.onFilter($event.target)" />
      <button
        mat-icon-button
        [style.visibility]="mainFilter.value.length > 0 ? 'visible' : 'hidden'"
        (click)="mainFilter.value = ''; gridWrapper.clearFilter()"
      >
        <mat-icon>clear</mat-icon>
      </button>
    </ng-template>

    <kendo-grid-column field="nomSousSysteme" title="Sous-système" filterable="false" width="150"> </kendo-grid-column>
    <kendo-grid-column field="descriptionCodeReponse" title="Statut" width="150">
      <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
        <app-multicheck-filter
          [isPrimitive]="true"
          [field]="column.field"
          [filterService]="filterService"
          [currentFilter]="filter"
          [data]="distinctPrimitive(column.field)"
        ></app-multicheck-filter>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-column field="message" title="Message" filterable="false"> </kendo-grid-column>
    <kendo-grid-column field="numeroPgm" title="PGM" [width]="200" filterable="false">
      <ng-template kendoGridGroupHeaderTemplate let-group="group">
        <div
          style="display: flex; flex-direction: column; overflow: hidden; white-space: nowrap"
          [title]="getRapportDescription(group) + ' ' + getRapportCommentaire(group)"
        >          
          <strong style="text-overflow: ellipsis">{{ getRapportDescription(group) }}</strong>
          <span style="font-size: 1.4ch; text-overflow: ellipsis">{{ getRapportCommentaire(group) }}</span>
        </div>
      </ng-template>
    </kendo-grid-column>
  </kendo-grid>

  <button mat-raised-button color="primary" (click)="applyPgms()">Appliquer</button>
</div>
